import { render, staticRenderFns } from "./BattleHeading.vue?vue&type=template&id=ec3a134a&scoped=true"
import script from "./BattleHeading.vue?vue&type=script&lang=js"
export * from "./BattleHeading.vue?vue&type=script&lang=js"
import style0 from "./BattleHeading.vue?vue&type=style&index=0&id=ec3a134a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3a134a",
  null
  
)

export default component.exports